import React, { FC } from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import { Avatar } from "@material-ui/core";
import OverflowTooltip from "../../../components/OverflowTooltip/OverflowTooltip";
import { IConversationItemProps } from "../types";
import BlinkingDot from "../../../components/BlinkingDot";

const useStyles = makeStyles(() => ({
  root: {
    width: 343,
    height: 72,
    padding: "11px 16px",
    borderRadius: 16,
    border: "1px solid #DBDBDB",
    display: "flex",
    columnGap: 16,
    "& + &": {
      marginTop: 10,
    },
    "&:hover": {
      boxShadow: "0px 0px 8px #C2C9D6B3",
      cursor: "pointer",
      border: "1px solid #FFF",
    },
  },
  selected: {
    backgroundColor: "#EEEFF3",
    border: "unset",
    "&:hover": {
      cursor: "default",
      boxShadow: "unset",
      border: "unset",
    },
  },
  avatar: {
    width: 50,
    height: 50,
  },
  info: {
    paddingTop: 5,
  },
  name: {
    fontSize: 14,
    fontWeight: 500,
    color: "#192130",
    width: 245,
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
  },
  text: {
    width: 245,
    marginTop: 4,
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
    fontSize: 14,
    color: "#858997",
  },
  unreadMessage: {
    color: "#7D9EF1",
    fontWeight: "bold",
  },
}));

export const ConversationItem: FC<IConversationItemProps> = React.memo(
  ({ conversation, isSelected, changeSelectedConversationInfo }) => {
    const classes = useStyles();

    return (
      <div
        onClick={() =>
          changeSelectedConversationInfo(conversation.userRole, conversation.id)
        }
        className={clsx(classes.root, isSelected && classes.selected)}
      >
        <BlinkingDot isVisible={!conversation.isSeen}>
          <Avatar src={conversation.photo} className={classes.avatar} />
        </BlinkingDot>
        <div className={classes.info}>
          <div className={classes.name}>
            <OverflowTooltip text={conversation.name} />
          </div>
          <div
            className={clsx(
              classes.text,
              !conversation.isSeen && classes.unreadMessage,
            )}
          >
            {conversation.text}
          </div>
        </div>
      </div>
    );
  },
);
